import TKFormRangeslider from '@tk/controls/tk.form.rangeslider';
import nouislider from 'nouislider';

export default class DIWFormRangeslider extends TKFormRangeslider {
    isSingleHandle: boolean;
    private isUpdating: boolean = false;

    constructor() {
        super();
        this.isSingleHandle = this.hasAttribute('data-tk-single-handle');

        this.decimal =
            Number(this.getAttribute('datak-tk-range-dec')) >= 0 ? Number(this.getAttribute('datak-tk-range-dec')) : 2;
    }

    connectedCallback() {
        // For single-handle mode, skip if only one field exists
        if (this.isSingleHandle) {
            if (!this.fieldElementFrom || !this.sliderElement) return;

            const value = Number(this.fieldElementFrom.value);
            const start = value >= this.rangeMin && value <= this.rangeMax ? value : this.rangeMin;

            this.rangeSlider = nouislider.create(this.sliderElement, {
                cssPrefix: 'tk-rangeslider-',
                start: start,
                connect: [true, false],
                range: {
                    min: this.rangeMin,
                    max: this.rangeMax,
                },
                step: this.rangeStep,
                format: {
                    to: (value: number) => this.formatDecimal(value),
                    from: (value: string) => this.formatDecimalToNumber(value),
                },
            });

            this.rangeSlider.on('update', this.updateField.bind(this));
            this.rangeSlider.on('set', () => {
                this.removeIgnoreField();
                if (!this.isUpdating) {
                    this.dispatchChangeEvent();
                }
            });

            this.disabled && this.rangeSlider.disable();

            this.registerInputListener();
        } else {
            // Use parent implementation for dual-handle mode
            super.connectedCallback();
        }
    }

    registerInputListener() {
        if (this.isSingleHandle) {
            if (!this.fieldElementFrom) return;
            const updateRangeSlider = () => {
                this.isUpdating = true;
                this.rangeSlider?.set(this.fieldElementFrom?.value || 0);
                setTimeout(() => (this.isUpdating = false), 0);
            };
            this.pushListener({ event: 'change', element: this.fieldElementFrom, action: updateRangeSlider });
        } else {
            super.registerInputListener();
        }
    }

    updateField(values: (number | string)[]) {
        if (!this.fieldElementFrom) return;
        this.fieldElementFrom.value = String(values[0]);
        if (this.fieldElementTo) {
            this.fieldElementTo.value = String(values[1]);
        }
    }

    dispatchChangeEvent() {
        // Dispatch change event only when slider movement is complete
        this.fieldElementFrom?.dispatchEvent(new Event('change', { bubbles: true }));
        if (this.fieldElementTo) {
            this.fieldElementTo.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
}
